import { useState, useEffect } from "react";
import taskOptions from "../../util/defaults/tareas";

function useEmployeeTaskOptions(businessCountry: string) {
  const [tasksOptions, setTasksOptions] = useState(
    [] as { value: string; label: string }[]
  );

  useEffect(() => {
    const newTasks: { value: string; label: string }[] = [];
    let filter = "es";
    if (businessCountry === "fr") {
      filter = "fr";
    }

    // eslint-disable-next-line
    taskOptions.map((item: any) => {
      if (item.businessCountry === filter) {
        newTasks.push({
          value: item.value,
          label: item.label,
        });
      }
    });

    setTasksOptions(newTasks);
  }, [businessCountry]);

  return tasksOptions;
}

export default useEmployeeTaskOptions;
